var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var BookmarkIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 38,
    glyphHeight: 53
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.2323V43.8192L17.408 36.6884C18.3808 36.0803 19.6152 36.0803 20.588 36.6882L32 43.8199L32 6.2323H6ZM1.46447 1.69677C2.40215 0.759086 3.67392 0.2323 5 0.2323H33C34.3261 0.2323 35.5979 0.759088 36.5355 1.69677C37.4732 2.63445 38 3.90622 38 5.2323L38 49.2323C38 50.3228 37.4082 51.3275 36.4544 51.8562C35.5006 52.3849 34.335 52.3543 33.4101 51.7764L18.9983 42.77L4.59013 51.7762C3.66533 52.3543 2.49966 52.3849 1.54576 51.8563C0.591861 51.3276 0 50.3229 0 49.2323V5.2323C0 3.90622 0.526786 2.63445 1.46447 1.69677Z",
    fill: "black"
  }));
};
export var BookmarkIconGlyph = function (props) {
  return React.createElement(BookmarkIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};